<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'UI'
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/ui/Home.vue